import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 1.1, ease },
};

export const fade = {
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 1.4, ease },
};

export function Reveal({ as: Tag = "div", delay = 0, children, ...rest }) {
    const Component = motion[Tag] || motion.div;
    return (
        <Component
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.18 }}
            transition={{ duration: 1.1, ease, delay }}
            {...rest}
        >
            {children}
        </Component>
    );
}

export function ImageReveal({ src, alt, className = "", priority = false }) {
    return (
        <motion.div
            className={`overflow-hidden ${className}`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.4, ease }}
        >
            <motion.img
                src={src}
                alt={alt}
                loading={priority ? "eager" : "lazy"}
                initial={{ scale: 1.08 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 1.6, ease }}
                className="block w-full h-full object-cover"
            />
        </motion.div>
    );
}
